import InvoiceStatusBadge, {
  optionsForInvoiceStatus,
} from './InvoiceStatusBadge';
export { optionsForInvoiceStatus };
export default InvoiceStatusBadge;
